<template>
    

    <form v-on:submit.prevent="createProject()" class="modal-card" >
        
        <section class="modal-card-body" style="height: auto">
            <div class="container">
            <button
            type="button"
            class="delete"
            @click="$emit('close')"/>
        
            <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false">
            </b-loading>
            
            <b-steps	
            size="is-small"
            label-position="bottom"
            :animateInitially="false"
            v-model="setupStep"
            :has-navigation="false">
        

                <b-step-item step="Type" :label="'Create Project for '+modelTypeList.filter( i => i.id == modelType)[0].name" icon="help">
                    <!-- <h1 class="title has-text-centered">Select a model output</h1> -->
                    <h2 class="subtitle is-4 has-text-centered">
                        <small>
                            <!-- <p class="subtitle is-7 is-uppercase">TASK TYPE</p> -->
                            <!-- Choose a Model Type -->
                        </small>
                    </h2>

                    <div class="columns is-centered">
                        <div class="column is-8 is-mobile">
                            <div class="columns">
                                <div class="column is-full">
                                    <!-- <b-notification 
                                        type="is-info" 
                                        aria-close-label="Close notification">
                                        <h3 class="title is-5">
                                        Select a task to customize your language AI model
                                        </h3>
                                        <p class="subtitle is-6">
                                            Select a task to get started, join to our early access tasks, or hire our developers partners if you need an expert. Read our quickstart for more guidance. Empower your AI aspirations today!
                                        </p>
                                    </b-notification> -->
                                    <div class="setup-grid setup-center">
                                        <div  v-for="i in modelTypeList">
                                            <!-- <span class="has-text-centered">{{ i.name }}</span> -->
                                            <span v-if="i.id == 'hire'" >
                                                <a href='https://tally.so/r/w4J1Qr' target="_blank">
                                                    <b-image :class="'card setup '" :src="require(`@/images/ai-task-${i.id}.svg`)" 
                                                        style="max-height: 15em; min-width: 10em;">
                                                    </b-image>
                                                    <!-- <b-tag style="top: -10px">Hire a developer</b-tag> -->
                                                </a>
                                            </span>
                                            <a v-else-if="i.id == 'generation'"  @click="joinEarlyAccess">
                                            <b-image :class="'card setup '+(modelType == i.id?'setup-selected-x':'')" :src="require(`@/images/ai-task-${i.id}.svg`)" 
                                                    style="max-height: 15em; min-width: 10em;">
                                            </b-image>
                                            <b-tag style="top: -10px">Coming soon</b-tag>
                                            </a>
                                            <span v-else>
                                                <a @click="modelType = i.id;">
                                                    <b-image :class="'card setup '+(modelType == i.id?'setup-selected':'')" :src="require(`@/images/ai-task-${i.id}.svg`)" 
                                                            style="max-height: 15em; min-width: 10em;">
                                                    </b-image>
                                                
                                                </a>
                                            </span>
                                        </div>
                                        <br>
                                    </div>
                                    <hr>
                                    <Try :modelType="modelType"/>
                                </div>
                        </div>
                        </div>
                        
                    </div>
                    
                </b-step-item>


                <!-- <b-step-item step="Setup" label="Setup" icon="help">

                    <div class="columns is-centered">
                        <div class="column is-8 is-mobile">
                            <div class="columns">
                                <div class="column is-full">
                                    
                                    <hr>
                                    <Try :modelType="modelType"/>
                                </div>
                        </div>
                        </div>
                        
                    </div>
                    
                </b-step-item> -->
                
                <b-step-item step="" label="Training samples">
                    <h2 class="subtitle is-4 has-text-centered">
                        <small>
                            <p class="subtitle is-7 is-uppercase">ADD TRAINING SAMPLES</p>
                            <!-- Choose a Data Source -->
                        </small>
                    </h2>
                    <div class="columns is-centered">
                        
                    <div class="column is-6 is-desktop">
                        <div class="columns is-centered">
                            <div class="column is-full is-mobile is-pulled-left" v-if="inputTask">
                            <b-button type="is-white" @click="inputTask = false">
                                <i class="fa fa-chevron-left"></i> Back to sources
                            </b-button>
                            
                            </div>
                        </div>
                            <br>
                        
                    
                    <div class="columnsx is-centered" v-if="!inputTask">
                        
                                    <div class="setup-grid-input setup-center">
                                        <div  v-for="i in inputTaskList">
                                            <!-- <span class="has-text-centered">{{ i.name }}</span>
                                            <br> -->
                                            <a @click="inputTask = i.id">
                                            <b-image :class="'card setup '+(inputTask == i.id?'setup-selected':'')" 
                                                    :src="require(`@/images/ai-input-${i.id}.svg`)"
                                                    style="max-height: 10em; min-width: 2em;">
                                            </b-image>
                                            </a>
                                        </div>
                                    
                        </div>
                        
                        
                    </div>
                    
                    <div class="columns">
                        <div class="column is-12">
                            <div class="columns">
                        
                        <div class="column is-12" v-if="inputTask == 'library'">
                            <div class="box" v-if="currentUser && (currentUser.creditsLimit - currentUser.creditsTotal) < 1">
                                <b-notification  type="is-warning" :closable="false" v-if="(currentUser.creditsLimit - currentUser.creditsTotal) < 1">
                                    <h4 class="title is-4">
                                        Records Quota Exceeded :/
                                    </h4>
                                    <p>Your current record usage is {{ currentUser.creditsTotal }}, your plan quota is {{ currentUser.creditsTotal }}.</p>
                                    <p>Get additional credits or upgrade to a higher plan to upload more records.</p>
                                    <p>Feel free to get in touch for tailored solutions: help@metatext.io</p>
                                </b-notification>
                            </div>
                            <div class="box" v-else-if="importDataCompleted">
                                <h4 class="title is-4"><i class="fa fa-check" aria-hidden="true"></i> Dataset metatext/{{ selectedDataset }} uploaded!</h4>
                            </div>
                            <div class="box" v-else>
                                <h4 class="title is-4">Add your data</h4>
                                    <p class="subtitle is-6">
                                        Select a dataset from our library to get started.
                                    </p>
                                    
                                    <div v-for="dataset in datasetsLibrary" :key="dataset.id">
                                        <b-radio v-model="selectedDataset" class="" :label="dataset.name" :native-value="dataset.id" >
                                            <b>metatext/{{ dataset.id }}</b><br>
                                            {{ dataset.name }}<br>
                                            <small>{{ dataset.description }}</small>
                                        </b-radio>
                                        <hr style="max-height: 1px;">
                                    </div>
                                    
                                    <b-button type="is-info" @click="createDatasetFromLibrary" :disabled="isLoading || importDataCompleted" expanded>Select</b-button>
                                    <br><br><br>
                                
                            </div>
                        </div>
                        <div class="column is-12" v-else>
                            
                            <Uploads v-if="inputTask" @datasetId="getDatasetId" @isComplete="getImportStatus" @labels="getLabels" :isOnboarding="true" :project="project" :currentUser="currentUser" :projectDocuments="[]" :inputTask="inputTask"/>
                            
                        </div>
                        </div>
                    </div>
                        
                        </div>
                        </div>

                        <div class="column is-6 desktop">
                            
                        <div class="is-pulled-right">
                            <b-button @click="getRows" type="is-white">
                                <b>Records:</b> {{  rows.length }} / {{  getCreditsOrRecordsLimit() }}
                            </b-button>
                            <b-button tag="router-link" :to="'/account/checkout'">
                                Upgrade
                            </b-button>
                        
                        </div>
                        <br><br>
                                    <div class="content pb-50" v-for="row in rows">
                            <Records :row="row" :train="true" :project="project" :currentUser="currentUser"></Records>
                        </div>
                                </div>
                </div>
                </b-step-item>
                
               

                <b-step-item step="" label="Annotation">
                    <div class="columns">
                        <div class="column is-8 is-offset-2">
                            <div class="columns">
                        
                                <div class="column is-full">

                                    <span v-if="availableTasks.includes(modelType)">
                                        <h2 class="subtitle is-4 has-text-centered">
                                            <small>
                                                <p class="subtitle is-7 is-uppercase">ANNOTATE YOUR DATA</p>
                                                
                                            </small>
                                        </h2>

                                        <div class="columnsx">
                        <div class="columnx is-10 is-offset-1">
                    <b-notification 
                        type="is-info" 
                        aria-close-label="Close notification">
                        <h3 class="title is-5">
                            Teach the AI what you want to do
                        </h3>
                        <p class="subtitle is-6">
                            Annotate your provided data to teach the AI to learn the patterns and replicate them to the unseen data.
                            Keep the meaningful ones and remove irrelevant ones to improve predictions. 
                            Your annotations improve predictions and model performance.
                        </p>
                    </b-notification>
                    <br>
                    </div>
                    </div>
                    
                    <b-field class="control" grouped>
                        <b-taginput
                                    size="is-"
                                    type="is-info"
                                    expanded
                                    @click="createProjectDraft"
                                    @close="createProjectDraft"
                                    @input="createProjectDraft"
                                    v-model="labels"
                                    :allow-new="true"
                                    :open-on-focus="true"
                                    placeholder="➕ Add a label">
                                </b-taginput>
                        <b-field position="is-right">
                        <p class="control">
                        <div class="is-pulled-right">
                            <b-button @click="getRows" type="is-white">
                                <b>Records added:</b> {{  rows.length }}
                            </b-button>
                        </div>
                        </p>
                        </b-field>
                    </b-field>
                                        
                                        <!-- <b-button type="is-ghost" @click="getRows">Refresh records</b-button> -->
                                        <br>
                                        
                                        <div class="content pb-50" v-for="row in rows">
                                            <Records :row="row" :train="true" :project="project" :currentUser="currentUser"></Records>
                                        </div>
                                        
                                        
                                    </span>
                                    <span v-else>
                                        <br><br>
                                        <h2 class="subtitle is-4 has-text-centered">
                                            💳 Subscribe to <b-tag size="is-small" type="is-dark">PRO</b-tag> plan 
                                        </h2>
                                        
                                        <h2 class="subtitle is-5">
                                            Subscribe to activate the engine for your account.
                                        </h2>
                                        <br>
                                        <p class="has-text-centered">
                                            Let us know if you need some help. Ask via chat or e-mail help@metatext.io
                                        </p>
                                        <br><br><br>
                                        
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-step-item>

                <b-step-item step="" label="Review">
                        
                        <h2 class="subtitle is-4 has-text-centered">
                            <small>
                                <p class="subtitle is-7 is-uppercase">Review</p>
                                Your project details
                            </small>
                        </h2>
                        <div class="columns">
                        <div class="column is-half is-offset-one-quarter">
                            <div class="columns">
                        
                                <div class="column is-8 is-offset-2">

                        <b-field label="Name">
                            <b-input
                                type="text"
                                size="is-medium"
                                v-model="projectName"
                                placeholder="Project name"
                                required>
                            </b-input>
                        </b-field>
                        <b-field label="Task type">
                            <b-input
                                disabled
                                type="text"
                                size="is-medium"
                                v-model="modelType"
                                required>
                            </b-input>
                        </b-field>
                        <b-field label="Labels" v-if="modelType == 'classification'">
                            <b-taginput
                                size="is-medium"
                                type="is-info"
                                expanded
                                :autocomplete="true"
                                v-model="labels"
                                :allow-new="true"
                                :open-on-focus="true"
                                placeholder="➕ Add a label">
                            </b-taginput>
                        </b-field>
                        <b-field label="Language">
                            <b-select v-model="projectLanguage" size="is-medium" name="language" required expanded  placeholder="Choose a language">
                                <option value='Multilingual' selected>Multilingual</option>
                                <option v-for="l in ['English', 'Mandarin / Chinese', 'Hindi', 'Spanish', 'Portuguese', 'French', 'Arabic', 'Other - Multilingual']" :value="l">{{ l }}</option>
                            </b-select>
                        </b-field>
                        
                        <b-field label="Model size" message="Select the size of the model's capacity. Model capacity refers to the model's ability to learn complex patterns in data. Usually, Small size is better for fast inference cases and Large for better accuracy.">
                            <b-select v-model="baseModel" size="is-medium" placeholder="Select a model size" expanded>
                            
                                <option value="small">Small</option>
                                <option value="medium">Medium</option>
                                <option value="large" :disabled="userPlan() != 'pro'">
                                    Large
                                    <b-tag v-if="userPlan() != 'pro'" type="is-dark">(Available on PRO plan)</b-tag>
                                </option>
                            </b-select>
                            
                        </b-field>
                       
                        
                        
                    </div></div></div></div>
                    
                </b-step-item>

                <b-step-item step="" :label="setupStep>=4?'':''" v-if="setupStep > 4">
                        
                        <h2 v-if="isLoading" class="subtitle is-4 has-text-centered">
                            <small>
                                <p class="subtitle is-7 is-uppercase">SETUP</p>
                                    Creating your project AI...
                            </small>
                        </h2>
                        <h2 v-else class="subtitle is-4 has-text-centered">
                            <small>
                                <p class="subtitle is-7 is-uppercase">SETUP</p>
                                    Congratulations!
                            </small>
                        </h2>
                        <div class="columns">
                        <div class="column is-half is-offset-one-quarter">
                            <div class="columns">
                        
                                <div class="column is-4 is-offset-4">
                                    
                                    <div class="boards-grid setup-center" v-if="projectId">

                                        <a @click="redirect" class="card board">
                                        
                                        <div class="card-content info" type="is-info">
                                            <div class="content">
                                            <div class="media-content">
                                                
                                                <p class="name title is-5">
                                                {{project.name}}
                                                </p>
                                                <p class="description is-6">
                                                <span v-if="project.description != undefined">
                                                    {{ project.description }}
                                                </span>
                                                <span v-else>
                                                    &nbsp;
                                                </span>
                                                </p>
                                            </div>
                                            </div>
                                            <div class="bottom">
                                                
                                                <b-tag type="is-info">
                                                {{ project.annotationMode?'annotation':'training' }}
                                                </b-tag>
                                                <b-tag type="is-secondary" class="is-pulled-right">
                                                {{ project.type }}
                                                </b-tag>
                                            </div>

                                            </div>
                                        </a>

                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    
                </b-step-item>
                
                <template
                #navigation="{previous, next}">
                    <div class="footer">
                        
                    <b-field>
                        <b-button
                            expanded
                            type="is-light"
                            size="is-medium"
                            icon-pack="fas"
                            icon-left="angle-left"
                            :disabled="previous.disabled"
                            @click.prevent="previous.action">
                            Previous
                        </b-button>
                        <b-button
                            tag="router-link"
                            size="is-medium"
                            expanded
                            v-if="setupStep == 0 && !availableTasks.includes(modelType)"
                            class="" 
                            :to="`/account/checkout`">
                            Join our early access
                            <!-- <b-tag size="is-small" type="is-dark">Enterprise</b-tag> -->
                        </b-button>
                        <!-- <b-button
                            v-else-if="setupStep == 0"
                            expanded
                            size="is-medium"
                            icon-pack="fas"
                            icon-right="angle-right"
                            :disabled="next.disabled"
                            @click.prevent="next.action">
                            Add training data
                        </b-button> -->
                        <b-button
                            v-else-if="setupStep == 0"
                            expanded
                            size="is-medium"
                            icon-pack="fas"
                            icon-right="angle-right"
                            :disabled="next.disabled"
                            @click="createProjectDraft"
                            @click.prevent="next.action">
                            Setup
                        </b-button>
                        <b-button
                            v-else-if="setupStep == 1"
                            expanded
                            type="is-info"
                            size="is-medium"
                            icon-pack="fas"
                            icon-right="angle-right"
                            :disabled="next.disabled || (!importDataCompleted && inputTask != 'api')"
                            @click="createProjectDraft"
                            @click.prevent="next.action">
                            Continue
                        </b-button>
                        <b-button
                            v-else-if="setupStep == 3 && availableTasks.includes(modelType)"
                            tag="button"
                            @click="createProject"
                            size="is-medium"
                            label="Create"
                            type="is-info"
                            expanded 
                            :disabled="!availableTasks.includes(modelType) || !projectName">
                        </b-button>
                        <b-button
                            v-else-if="setupStep == 5 && availableTasks.includes(modelType)"
                            tag="button"
                            @click="redirect"
                            size="is-medium"
                            label="Get started"
                            type="is-info"
                            expanded 
                            :disabled="!availableTasks.includes(modelType)"/>
                        <b-button
                            v-else
                            expanded
                            size="is-medium"
                            icon-pack="fas"
                            icon-right="angle-right"
                            
                            :disabled="next.disabled"
                            @click.prevent="next.action">
                            Review
                        </b-button>
                    </b-field>
                    
                    </div>
                </template>
                
            </b-steps>
        </div>
            

        </section>
    </form>
    
    </template>
    <script>
    

import Uploads from "@/dashboard/Project/Uploads.vue";
import Records from "@/dashboard/Project/Records.vue";
import Try from "@/components/ProjectCreateTry.vue";

export default {
      props: {
        stepId: String
      },
      data() {
        
        return {
            projectId: null,
            importDataCompleted: false,
            projectCreated: false,
            setupStep: 0,
            showSteps: false,
            labels: [],
            try_records: [],
            text: "John Doe works at ABC Corporation in New York. The event will be held at 9:00 AM on May 20, 2023.",
            adding_label: undefined,
            inference_result: false,
            add_as_records: false,
            readyToCreate: false,
            isLoading: false,
            projectName: null,
            projectLanguage: 'Multilingual',
            projectDescription: false,
            projectLabels: [],
            settings: {
                readOnly: true,
                rowHeaders: true,
                licenseKey: 'non-commercial-and-evaluation'
            },
            inputTaskList: [{id: 'manual', name: 'Generate texts'}, {id: 'csv', name: 'From CSV'}, {id: 'pdf', name: 'From any DOC'},{id: 'library', name: 'From Our Library'}],
            inputTask: false,
            availableInputTask: ['csv', 'pdf', 'html', 'library', 'api', 'manual'],
            baseModel: 'medium',
            modelType: null,
            modelTypeList: [
                {id: 'classification', name: 'Classification', step: 'train'},
                {id: 'extraction', name: 'Extraction', step: 'finetune'},
                {id: 'generation', name: 'Generation', step: 'finetune'},
                {id: 'hire', name: 'Hire a Metatext Partner'}
            ],
            availableTasks: ['classification', 'extraction', 'generation'],
            datasetsLibrary: [
                {id: 'ag_news', name: 'Topic classification', description: "News articles from 4 categories: World, Sports, Business, Sci/Tech"},
                // {id: 'banking77', name: 'Intent recognition', description: "Banking support tickets from 12 categories"},
                // {id: 'sst2', name: 'Sentiment analysis', description: "Movie reviews from 2 categories: positive, negative"},
            ],
            sampleDataframe: false,
            datasetName: '',
            isFinished: false,
            selectedDataset: 'ag_news',
            csv: null,
            label_col: false,
            text_col: false,
            animated: true,
            imageData: null,
            file2: false,
            picture: null,
            files: [],
            uploadValue: 0,
            csv: 1,
            json: 1,
            previewDataset: null,
            isComponentModalActive: false,
            isComponentDatasetEditActive: false,
            selectedTask: null,
            columns: [
                {
                    field: 'task',
                }
            ],
        };
      },
      components: {
        Uploads,
        Records,
        Try
      },
      created() {
        this.$store.dispatch("currentUser");
      },
      filters: {
            pretty: function(value) {
                console.log(value)
                return JSON.stringify(value, null, 2);
            }
      },
      computed: {
        project() {
            return this.$store.state.project;
        },
        currentUser() {
          return this.$store.state.currentUser;
        },
        currentOrg() {
          return this.$store.state.currentOrg;
        },
        plans() {
            return this.$store.state.plans
        },
        datasets() {
            return this.$store.state.datasets //publicDatasets
        },
        rows() {
            if (this.project.datasetId){
                return this.$store.getters.rowsByDataset(this.project.datasetId)
            } else {
                return []
            }
        },
      },
      mounted(){
        let stepId = this.$route.params.stepId
        
        this.modelType = (stepId?stepId:'classification')
        console.log(stepId, this.modelType)
        this.$store.dispatch("retrieveAllDatasets", this.projectId);
      },
      watch: {
        // whenever question changes, this function will run
        projectId() {
            if (this.projectId != null) {
                this.$store.dispatch("currentProject", this.projectId);
            }
        },
        project(){
            this.getLabels()
            this.getRows()
        }
      },
      methods:{
        userPlan(){
            let plan = this.currentUser.plan.name.toLowerCase()
            return plan ? plan : "starter"
        },
        getCreditsOrRecordsLimit(){
            let remaining = this.currentUser.creditsLimit-this.currentUser.creditsTotal
            return  remaining < this.currentUser.plan.datasetRowsLimit ? remaining: this.currentUser.plan.datasetRowsLimit
        },
        getRecords(){

        },
        createDatasetFromLibrary(){
            let datasetLibraryName = this.selectedDataset
            const dataset = {
                    projectId: this.projectId
            }
            console.log(dataset)
            
            var newDataset = this.$store.dispatch("createDataset",
                dataset
            )

            newDataset.then(datasetId => {
                
                const addDatasetToProject = {
                        projectId: this.projectId,
                        update: {
                            datasetId: datasetId,
                        }
                }

                console.log(addDatasetToProject)
                
                this.$store.dispatch("addDatasetToProject",
                    addDatasetToProject
                )

                this.project.datasetId = datasetId
                this.datasetId = datasetId

                const datasetUpload = {
                    datasetId: datasetId,
                    projectId: this.projectId,
                    datasetLibraryName: datasetLibraryName,
                    filename: `metatext/${datasetLibraryName}`,
                }

                console.log(datasetUpload)

                var newUpload = this.$store.dispatch("increaseDataset",
                    datasetUpload
                )

                newUpload.then(uploadId => {
                    this.isLoading = true
                    this.$store.dispatch("datasetAnalysis",{datasetId: datasetId, uploadId: uploadId}).then( (res) => {
                        let status = res.status
                        let records = res.records
                        this.$buefy.dialog.confirm({
                                message: `${status}. ${records} records added\n\n`,
                                canCancel: false,
                                onConfirm: () => {
                                    this.isLoading = false
                                    if (status.toLowerCase().includes("completed")){
                                        this.getImportStatus(true)
                                    } else {
                                        this.getImportStatus(false)
                                    }
                                
                                    
                                }
                        })
                    })
                })
                
            }, (error) => {
                console.log(error)
            })
        },
        getImportStatus(isCompleted){
            this.importDataCompleted = isCompleted
            this.getRows()
        },
        getDatasetId(datasetId){
            this.datasetId = datasetId
        },
        title(){
            try {
                return this.engines[this.radioButton].title
            } catch {
                return false
            }
            
        },
        description(){
            try {
                return this.engines[this.radioButton].description
            } catch {
                return false
            }
        },
        stepCheck(){
            if (this.setupStep == 1){
                this.createProjectDraft()
            } else if (this.projectId != null){
                this.$store.dispatch("currentProject", this.projectId);
            }
        },
        setupCurrentStep(){
            let step = this.setupStep
            // classification, 0, 1, 2, 3, 4
            // classification, 0, 1, 2, 3, 4

        },
        getRows(){
            this.$store.dispatch('getRowsByDataset', this.datasetId)
        },
        getLabels(labels = null){
            if (this.project && "labels" in this.project){
                this.project.labels.forEach( (item) => {
                    if (!this.labels.includes(item.label)){
                        this.labels.push(item.label)
                    }
                })
            }

            if (labels){
                labels.forEach( (i) => {
                    this.labels.push(i)
                })
            }
            

        },
        createProjectDraft(){
            
            this.inputTask = false

            if (this.projectId != null){
                let projectLabels = this.updateProjectLabels()
                let toUpdate = {
                    projectId: this.projectId,
                    update: {
                        labels: projectLabels
                    }
                }
                
                var newDoc = this.$store.dispatch("updateProject",
                    toUpdate
                )
                this.$store.dispatch("currentProject", this.projectId).then( () => {
                    this.getRows()
                })
                return;
            }

            let projectLabels = []
            if(this.modelType === 'classification'){
                projectLabels = this.updateProjectLabels()
            }

            
            const project = {
                name: "Untitled",
                type: this.modelType,
                description: "",
                baseModel: this.baseModel,
                labels: projectLabels,
                userId: this.currentUser.id
            }

            var newDoc = this.$store.dispatch("createProject",
                project
            )
            const loadingComponent = this.$buefy.loading.open({
                    container: null
            })
                
            this.projectId = null
            newDoc.then(projectId => {
                
                this.projectId = projectId
                this.$store.dispatch("currentProject", projectId)

                setTimeout(() => {
                    loadingComponent.close()
                },  500)
            })
            
            
            

        },
        createRecords(projectId){
            if (this.try_records.length){
                    
                this.try_records.forEach( (record, index, array) => {
                    
                    this.$store.dispatch(
                            "addRecord",
                            {   text: record.text, 
                                labels: record.labels, 
                                projectId: projectId
                            }
                        )
                    }).then( record_data => {
                        
                        console.log(record_data)
                        this.getDatasetId(record_data['dataset_id'])
                    })
                }
            
        },
        updateProjectLabels(){
            let projectLabels = []
            this.labels.forEach(function (label, i) {
                projectLabels.push({label_code: i, label: label})
            });
            
            // if (this.project){
            //     alert(`labels ${this.project.id}`)
            //     // Create a project
            //     const projectToUpdate = {
            //         projectId: this.project.id,
            //         update: {
            //             labels: projectLabels
            //         }
            //     }

            //     this.$store.dispatch("updateProject",
            //         projectToUpdate
            //     )
            // }
            
            return projectLabels
        },
        createProject(){
            // Ask for at least one label
            if(this.modelType === 'classification' && this.labels.length < 1){
                this.$buefy.dialog.alert({
                    message: '<b>Must provide at least one label to your project.</b><br><br><b>For example, for spam detection:</b><br>You can provide the output labels (categories) spam and not spam. The model will learn how to categorize the texts into this labels.<br><br>If you already have a dataset annotated with labels, please add the first one label, then in the next step you will upload your CSV file and all the labels will be loaded automatically.',
                });
                return;
            }

            // Set loading spinning
            this.isLoading = true
            
            // Fix labels
            let projectLabels = []
            if(this.modelType === 'classification'){
                projectLabels = this.updateProjectLabels()
                if (projectLabels.length == 1){
                    projectLabels.push({label_code: projectLabels[0].label_code, label: `not ${projectLabels[0].label}`})
                }
            }
            
            // Retrieve datasetId from project or Upload
            const datasetId = (this.project.datasetId?this.project.datasetId:this.datasetId)

            // Create a model
            const model = {
                projectId: this.projectId,
                type: this.modelType,
                trigger: true,
                size: this.baseModel,
                language: this.projectLanguage,
                datasetId: datasetId,
                userId: this.currentUser.id
            }

            var newDoc = this.$store.dispatch("createModel",
                model
            );

            newDoc.then(newModelId => {
                
                const addModelToProject = {
                  projectId: this.project.id,
                  add: {
                    models: [newModelId],
                    modelId: newModelId,
                  }
                }
                this.$store.dispatch("addModelToProject",
                  addModelToProject
                );
            });

            const toUpdateCreditsConsumed = {
                userId: this.currentUser.id,
                creditConsumed: this.creditsNeeded()
            }

            this.$store.dispatch("updateAPICreditsConsumed", 
                toUpdateCreditsConsumed
            );



            // Create a project
            const projectToUpdate = {
                projectId: this.projectId,
                update: {
                    name: (this.projectName)?this.projectName:"Untitled",
                    type: this.modelType,
                    labels: projectLabels,
                    language: this.projectLanguage,
                    inputTask: this.inputTask,
                    size: this.baseModel
                }
            }

            var newProjectDoc = this.$store.dispatch("updateProject",
                projectToUpdate
            )

            // Go though the final step onboarding
            newProjectDoc.then(() => {
                this.projectCreated = true
                this.setupStep = 5
            })

            this.isLoading = true
            
            setTimeout(() => {
                this.isLoading = false
            },  2*1000)
            
        },
        creditsNeeded(){
            let dot = 1//this.modelSizePrice[this.modelSize]
            return parseInt(this.rows.length)
        },
        enoughCredits(){
            let credits = this.currentUser.creditsRemaining
            let records = this.creditsNeeded()
            return credits >= records
        },
        availableCredits(){
            let credits = this.currentUser.creditsRemaining
            return credits | 0
        },
        joinEarlyAccess() {
                this.$buefy.dialog.confirm({
                    title: 'Join Early Access',
                    message: `<b>Extraction and generation tasks that are currently in development</b>. <br>Be among the first to experience the power of these features by joining our Early Access program. By joining, you'll have the <b>opportunity to test it for free before they're publicly launched</b>. Your feedback will be invaluable in shaping these features for the best user experience. <br><br>Click the button below to request Early Access.`,
                    cancelText: 'Cancel',
                    confirmText: 'Join Early Access',
                    type: 'is-primary',
                    onConfirm: () => window.open('https://tally.so/r/3EdBKl', '_blank')
                })
        },
        completeConfirm(){
            this.isLoading = false
            this.setupStep = 5
            // let content = `<b>Creating the ${this.projectName} project.</b><br><br>Now it's up to you, here is what you need to do in the next steps:<br><br>1. <b>Data labeling</b> your input data to teach your AI model how to classify.<br><br>2. <b>AI Text Classifier</b> will continuously training in background when you annotate.<br><br>3. Check the AI model training and call your AI model using <b>API</b><br><br>We're here to help you have a success journey with AI. Ask on the chat support 😃💬`
            // this.$buefy.dialog.confirm({
            //             message: content,
            //             canCancel: false,
            //             onConfirm: () => this.redirect(this.projectId) 
            // })
        },
        openLoading() {
                let isFullPage = true
                const loadingComponent = this.$buefy.loading.open({
                    container: isFullPage ? null : this.$refs.element.$el
                })
                setTimeout(() => loadingComponent.close(),  3*1000)
        },
        redirect(){
            let project_name = (this.projectName)?this.projectName:"Untitled"
            this.$buefy.toast.open(`Opening the project ${project_name}...`)
            
            let step = this.modelTypeList.filter( i => i.id == this.modelType)[0]['step']

            this.isLoading = true
            setTimeout(() => {
                this.$router.push(`/projects/${this.projectId}/${step}`)
            },  4)
            
        },
        highlight(result) {
            if (!result) return;

            if(this.modelType != 'extraction') {
                return result;
            }

            let highlight = []
            let highlight_text = this.text
            result.forEach(async (r) => {
                highlight_text = highlight_text.replace(new RegExp(r.text, "gi"), match => {
                    return `<span style="margin-bottom: 5px" data-entity="${r.label.toLowerCase()}">${match} <span class='entities-type'><b>${r.label}</b></span></span>`;
                });
                
                highlight.push(highlight_text)
            });
            
            return highlight.slice(-1)
        },
        runInference(){
            let model_type = this.modelType
            let text = this.text
            let labels = this.labels
            this.inference(model_type, text, labels)


        },
        inference(model_type, text, labels){
            let isFullPage = false
            this.isInference = true
            const loadingComponent = this.$buefy.loading.open({
                container: isFullPage ? null : this.$refs.inference_result.$el
            })
            this.$store.dispatch(
                "getPreBuildModelInference",
                {text: text, labels: labels, modelId: model_type}
            ).then( (res) => {
                this.isInference = false
                console.log(res)
                this.inference_result = {prediction: res}
                loadingComponent.close()
                
            })
        },
        addAsRecords(text, res){
            this.try_records.push({
                id: null,
                text: text,
                labels: res,
                createdAt: new Date().getTime()
            })
        }
      }
        
    }
    </script>
    <style lang="scss" scoped>

.item{
    display:flex;
    flex-direction:column;
    justify-content:space-between
  }

.columns button{
    margin-top: auto;
  }

.footer {
    position: fixed;
    height: 50px;
    bottom: -30px;
    left: 0px;
    right: 0px;
    margin-bottom: 0px;
}
.selected-setup {
    cursor: pointer;
    border: dashed 2px #3482F6;
    border-radius: 0px;
    min-height: 10em;
  
    &:hover {
      border: dashed 2px #1367e5;
    }
  }
  
.setup-grid-input {
    display: grid;
    justify-content: center;
    align-content: center;
    grid-auto-flow: column;
    grid-template-columns: repeat(auto-fill, minmax(100px, 2fr));
    gap: 1em;
  
    .setup-selected {
          border: dashed 3px #bdbdbd !important;
      }
  
    .setup {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
    grid-auto-flow: column;
    
    align-items: center;
    justify-items: center;
  
      &:hover {
        background: #fafafa;
        border: dashed 1px #bdbdbd;
      }
  
      &:active {
          border: dashed 2px #bdbdbd;
      }
  
      &:checked {
          border: dashed 2px #bdbdbd;
      }
      
  
      .info {
        padding: 16px;
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }
      }
    }
  }

.setup-grid {
    display: grid;
    justify-content: center;
    align-content: center;
    grid-auto-flow: column;
    grid-template-columns: repeat(auto-fill, minmax(140px, 2fr));
    gap: 3em;
  
    .setup-selected {
          border: dashed 2px #bdbdbd !important;
      }
  
    .setup {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
    grid-auto-flow: column;
    
    align-items: center;
    justify-items: center;
  
      &:hover {
        background: #fafafa;
        border: dashed 2px #bdbdbd;
      }
  
      &:active {
          border: dashed 2px #bdbdbd;
      }
  
      &:checked {
          border: dashed 2px #bdbdbd;
      }
      
  
      .info {
        padding: 16px;
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }
      }
    }
  }
  
  .setup-center {
    margin: 0 auto;
  }




  .boards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
    gap: 16px;
    
  
    .board-create {
      cursor: pointer;
      border: dashed 4px #e6e4e4;
      border-radius: 0px;
      min-width: 40em;
      min-height: 10em;
    
      &:hover {
        border: dashed 4px #bdbdbd;
      }
    }
    .board {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
      min-height: 10em;
  
      &:hover {
        background: #fafafa;
      }
  
      .info {
        padding: 16px;
        display:flex;
        flex-direction:column;
        justify-content:space-between
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }

        .bottom-left {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          left: 0.8em;
        }
        .bottom-right {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          right: 0.8em;
        }
      }
    }
  }
</style>